import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import RegisterView from '../views/RegisterView.vue'
import portal from '../views/portal.vue'
import onboardingView from '../views/onboardingView.vue'
import requestView from '@/views/requestView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView
  },
  {
    path: '/portal',
    name: 'portal',
    component: portal
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    component: onboardingView
  },
  {
    path: '/request',
    name: 'request',
    component: requestView
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
